import { FontAction, CommonAction } from 'Actions/index';
import { FontActionTypes, CommonActionTypes } from 'Actions/ActionTypes/index';
import { IFonts } from 'Store/IFonts';
import Util from 'Util/index';

/**
 * An empty array of Font objects.
 */
const initialState: IFonts = {};

/**
 * A function that maps queues from a invoked action to the current state.
 * @param {state} - The current state.
 * @param {action} - The action invoked by store.
 */
export const fonts = (state: IFonts = initialState, action: FontAction | CommonAction) => {

    let newState: IFonts;

    switch (action.type) {
        case FontActionTypes.AddFonts:
        case FontActionTypes.ModifyFonts:
            newState = { ...state };
            action.fonts.forEach(font => {
                newState[Util.IdToString(font.id!)] = font;
            });
            break;
        case FontActionTypes.DeleteFonts:
            newState = { ...state };
            action.ids.forEach(id => delete newState[Util.IdToString(id!)]);
            break;
        case CommonActionTypes.ClearStore:
            newState = initialState;
            break;
        default:
            newState = state;
    }
    
    return newState;
}